export const rejectedNotesCountKeys = {
  base: ["rejectedNotesCount"] as const,
  count: () => [...rejectedNotesCountKeys.base, "count"] as const,
} as const;
